export default __webpack_public_path__ + "static/media/left_portal.bf920456.png";